var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"primary","large":""},on:{"click":_vm.newUser}},[_vm._v(" "+_vm._s(_vm.$t('NEW USER'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }